// src/components/common/Sparkline.jsx
import React from 'react';
import { ResponsiveContainer, AreaChart, Area } from 'recharts';

const Sparkline = ({ data, color = '#652991', height = 30 }) => (
  <ResponsiveContainer width="100%" height={height}>
    <AreaChart data={data} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
      <Area 
        type="monotone" 
        dataKey="value" 
        stroke={color} 
        fill={color} 
        fillOpacity={0.2} 
      />
    </AreaChart>
  </ResponsiveContainer>
);

export default Sparkline;